export const DIVERSIFY_PORTFOLIO = "DIVERSIFY_PORTFOLIO";
export const DIVERSIFY_PORTFOLIO_ERROR = "DIVERSIFY_PORTFOLIO_ERROR";
export const DIVERSIFY_PORTFOLIO_HIDE_ERROR = "DIVERSIFY_PORTFOLIO_HIDE_ERROR";
export const DIVERSIFY_PORTFOLIO_START_LOADER = "DIVERSIFY_PORTFOLIO_START_LOADER";
export const DIVERSIFY_PORTFOLIO_STOP_LOADER = "DIVERSIFY_PORTFOLIO_STOP_LOADER";
